// Auto generated. Use `npm run icons` to regenerate.

// fab
import {
  faCanadianMapleLeaf as fabCanadianMapleLeaf,
} from "@fortawesome/free-brands-svg-icons";

// fal
import {
  faBriefcase as falBriefcase,
  faFileLines as falFileLines,
  faFlag as falFlag,
  faLock as falLock,
  faUser as falUser,
} from "@fortawesome/pro-light-svg-icons";

// fat
import {
  faCircleCheck as fatCircleCheck,
} from "@fortawesome/pro-thin-svg-icons";

// fass
import {
  faCheck as fassCheck,
} from "@fortawesome/sharp-solid-svg-icons";

import { library, config } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

library.add(
  fabCanadianMapleLeaf,
  falBriefcase,
  falFileLines,
  falFlag,
  falLock,
  falUser,
  fatCircleCheck,
  fassCheck
);

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('fa', FontAwesomeIcon, {})
})
